import React, { Component } from "react";
import axios from "axios";
import Empty from "../../image/empty.svg"
// import HeaderDashboard from "../../part/header.dashaboard";
import DashMenu from "../../part/dash_menu";
import FilterCourse from "../../part/filter_bar_course";
import ScrollCourseList from "../../part/course.scroll.for.list";
import FooterDashboard from "../../part/footer.dashboard";
import Policy from "../../part/policy";
import DashSearchHeader from "../../part/header.search.dashboard";

class PrivatePhysicalCourse extends Component {
  state = {
    filter_type_name: "Type",
    filter_level_name: "Level",
    filter_status_name: "Status",
    menuCoverWidth: this.getInitialMenuCoverWidth(),
    courses: [],
    isContactVisible: false,
  }
  getInitialMenuCoverWidth() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 900) {
      return 0;
    } else if (windowWidth >= 900 && windowWidth < 1200) {
      return 60;
    } else {
      return 260;
    }
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('mousedown', this.handleOutsideClick);
    this.fetchCourses();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  handleResize = () => {
    const menuCover = document.querySelector('.dashboard .menu_cover');
    if (menuCover) {
      this.setState({ menuCoverWidth: menuCover.offsetWidth });
    }
    this.setState({ windowHeight: window.innerHeight - 60 });
  };

  fetchCourses = async () => {
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await axios.get("https://api.geoinfoacademy.com/api/courses/", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      this.setState({ courses: response.data });
      console.log("API Response:", response.data);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("user");
        window.location.href = "/"; 
      } else {
        console.error("Error fetching data:", error);
      }
    }
  };
  initialfilterbytype = () => {
    const courses = this.state.courses;
    if (this.state.filter_type_name === "Type" || this.state.filter_type_name === "All") {
        return courses
    } else {
        return courses.filter((item) => item.labels === this.state.filter_type_name);

    }
};

initialfilterbylevel = () => {
    const courses = this.initialfilterbytype();
    
    if (this.state.filter_level_name === "Level" || this.state.filter_level_name === "All") {
        return courses
    }else if (this.state.filter_level_name === "Advance/Professional") {
        return courses.filter(
            (item) =>
                item.tags === "Advance" ||
                item.tags === "Professional"
        );
    }else if (this.state.filter_level_name === "Beginner to Advance/Professional") {
        return courses.filter(
            (item) =>
                item.tags === "Beginner to Advance" ||
                item.tags === "Beginner to Professional"
        );
    } 
    
     else {
        return courses.filter((item) => item.tags === this.state.filter_level_name);

    }
};
initialfilterbystatus = () => {
    const courses = this.initialfilterbylevel();
    if (this.state.filter_status_name === "Status" || this.state.filter_status_name === "All") {
        return courses
    } else if (this.state.filter_status_name === "Online") {
        return courses.filter(
            (item) =>
                item.training_type === "Online Prerecorded" ||
                item.training_type === "Online Live with Facilitator"
        );
    } 
    // If "Physical" is selected, filter for "general physical class" and "private physical class"
    else if (this.state.filter_status_name === "Physical") {
        return courses.filter(
            (item) =>
                item.training_type === "General Physical Class" ||
                item.training_type === "Physical Private Class"
        );
    } 
    // Default case: If filter_level_name matches a specific training_type directly
    else {
        return courses.filter(
            (item) => item.training_type === this.state.filter_status_name
        );
    }
};
handleFilterChange = (filterType, filterLevel,filterStatus) => {
    this.setState({
        filter_type_name: filterType,
        filter_level_name: filterLevel,
        filter_status_name: filterStatus,
    })
};




  GISfilterData = () => {
    const courses = this.initialfilterbystatus();
    const prerecord = courses.filter((item) => item.training_type === "Physical Private Class");
    return prerecord.filter((item) => item.labels === "GIS")
  };
  DronefilterData = () => {
    const courses = this.initialfilterbystatus();
    const prerecord = courses.filter((item) => item.training_type === "Physical Private Class");
    return prerecord.filter((item) => item.labels === "Drone")
  };
  RemoteSensingfilterData = () => {
    const courses = this.initialfilterbystatus();
    const prerecord = courses.filter((item) => item.training_type === "Physical Private Class");
    return prerecord.filter((item) => item.labels === "Remote Sensing")
  };
  SurveyfilterData = () => {
    const courses = this.initialfilterbystatus();
    const prerecord = courses.filter((item) => item.training_type === "Physical Private Class");
    return prerecord.filter((item) => item.labels === "Survey")
  };
  EventfilterData = () => {
    const courses = this.initialfilterbystatus();
    const prerecord = courses.filter((item) => item.training_type === "Physical Private Class");
    return prerecord.filter((item) => item.labels === "Event")
  };
  WebinarfilterData = () => {
    const courses = this.initialfilterbystatus();
    const prerecord = courses.filter((item) => item.training_type === "Physical Private Class");
    return prerecord.filter((item) => item.labels === "Webinar")
  };
  PodcastfilterData = () => {
    const courses = this.initialfilterbystatus();
    const prerecord = courses.filter((item) => item.training_type === "Physical Private Class");
    return prerecord.filter((item) => item.labels === "Podcast")
  };






  handleRefresh = () => {
    this.setState({
      filter_type_name: "Type",
      selectedItem: "",
      filter_level_name: "Level",
      selectedItems: "",
      filter_status_name: "Status",
      selectedIteme: ""
    },() => {
      // Important: Call the reset on the child!
      this.filterRef.handleReset(); // Assuming you add a ref to the FilterCourse component
    })
  }


  render() {
    const { menuCoverWidth } = this.state;
    const GISdata = this.GISfilterData()
    const Dronedata = this.DronefilterData()
    const Remotesensingdata = this.RemoteSensingfilterData()
    const Surveydata = this.SurveyfilterData()
    const Eventdata = this.EventfilterData()
    const Webinardata = this.WebinarfilterData()
    const Podcastdata = this.PodcastfilterData()

    return (
      <div className="dashboard">
        <DashSearchHeader onResize={this.handleResize}  />
        <DashMenu />
        <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 10px)`,overflow: `hidden` }}>
          <div className="course_head">
            <h2> Physical Private Class </h2>
            <FilterCourse 
              filterType={this.state.filter_type_name} // Pass current values as props
              filterLevel={this.state.filter_level_name}
              filterStatus={this.state.filter_status_name}
              onFilterChange={this.handleFilterChange}
              ref={(el) => this.filterRef = el}
            />
          </div>
          <div className="dash-main-scroll-cover">
          {/* <ScrollCourseList topics={this.state.courses} /> */}
          {GISdata.length > 0 && (<ScrollCourseList topics={GISdata}/>)}
          {Dronedata.length > 0 && (<ScrollCourseList topics={Dronedata} />)}
          {Remotesensingdata.length > 0 && (<ScrollCourseList topics={Remotesensingdata} />)}
          {Surveydata.length > 0 && (<ScrollCourseList topics={Surveydata} />)}
          {Eventdata.length > 0 && (<ScrollCourseList topics={Eventdata} />)}
          {Webinardata.length > 0 && (<ScrollCourseList topics={Webinardata} />)}
          {Podcastdata.length > 0 && (<ScrollCourseList topics={Podcastdata} />)}
          {GISdata.length === 0 && Dronedata.length === 0 && Remotesensingdata.length === 0 && Surveydata.length === 0 &&
            Eventdata.length === 0 && Webinardata.length === 0 && Podcastdata.length === 0 && (
              <div className="course_list_empty">
                <img src={Empty} alt="not avaialable" /><br />
                <h5>No available course <br />with that specification.</h5>
                <button onClick={this.handleRefresh}>Reset Filter</button>
              </div>
            )}
            </div>
            <FooterDashboard />
          <Policy />
        </div>
      </div>
    )
  }
}

export default PrivatePhysicalCourse